<template>
    <tr class="option-row">
        <td class="col-xs-3">
            {{child.name}}
        </td>
        <td class="col-xs-1">
            <a v-if="(child.kit.length > 0)" @click.prevent="setKitList" title="View the Kit List" class="btn btn-primary kit-list">
                <i class="glyphicon glyphicon-list-alt"></i> Kit List
            </a>
            &nbsp;
        </td>
        <td class="col-xs-1">£{{child.price}}</td>
        <td class="col-xs-3">
            <input v-model="quantity" type="number" class="form-control" name="quantity">
        </td>
        <td class="col-xs-2 col-md-4">
            <button class="btn btn-primary addProductSubmit" type="submit" @click.prevent="addToCart">
                <i class="fa fa-plus"></i> | Add to Cart
            </button>
        </td>
    </tr>
</template>
<script>
    export default {
        data() {
            return {
                quantity: 1
            }
        },

        props: ['child'],

        methods: {
            addButton( button, data = null ) {
                if ( !data ) {
                    button.className += " disabled";
                    button.innerHTML = '<i class="fa fa-spin fa-spinner"></i> Adding';
                } else {
                    if ( data.error ) {
                        button.className = 'btn btn-danger'

                    } else {
                        button.className = button.className.replace( new RegExp( '(?:^|\\s)' + 'disabled' + '(?:\\s|$)' ), ' ' );
                    }
                    button.innerHTML = data.text;
                }
            },

            addToCart() {
                let button = event.currentTarget;
                let item = {};
                this.addButton( button );
                this.$store.dispatch( 'addItemToCart', this.item ).then(
                    ( cart ) => {
                        this.addButton( button, { text: '<i class="fa fa-plus"></i> | Add to cart' } )
                    },
                    ( error ) => {
                        this.addButton( button, { text: 'Error adding item', error: error } );
                    }
                );
            },

            setKitList() {
                this.$store.commit('kitList', this.child.kit);
            }
        },

        computed: {
            item() {
                return {
                    product_id: this.child.id,
                    quantity: this.quantity,
                    cost: this.child.price
                }
            },

            hasChildren() {
                return (this.product.children.length > 0);
            }
        },
    }
</script>